import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgParkeren = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.833374 8.16667H21.1667V17.5H0.833374V8.16667ZM2.83337 10.1667V15.5H19.1667V10.1667H2.83337Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.15002 1.75H17.7668L19.5704 10.1667H3.34638L5.15002 1.75ZM6.76684 3.75L5.82037 8.16667H17.0964L16.15 3.75H6.76684Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.33337 13.8333H4.58337V11.8333H7.33337V13.8333Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6667 11.8333H17.4167V13.8333H14.6667V11.8333Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.58341 20.25V17.5H5.58341V20.25H2.58341Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.4167 20.25V17.5H19.4167V20.25H16.4167Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgParkeren);

export default ForwardRef;
